import { render, staticRenderFns } from "./LanguageAndTarget.vue?vue&type=template&id=64b1a309&"
import script from "./LanguageAndTarget.vue?vue&type=script&lang=ts&"
export * from "./LanguageAndTarget.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageAndTarget.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports